// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { accountMessagesStyles } from "@steiner/Overrides/Widgets/MyAccount/AccountMessages";
import { css } from "styled-components";

accountMessagesStyles.noMessagesGridItem = {
    width: 12,
};
accountMessagesStyles.noMessagesText = {
    ...dataTableStyles.noResultsText,
};

accountMessagesStyles.messageCard = {
    ...accountMessagesStyles.messageCard,
    gridContainer: {
        gap: 0,
    },
    bodyGridItem: { width: [12, 12, 12, 10, 10] },
    actionButtonGridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            justify-content: flex-end;
        `,
    },
};

accountMessagesStyles.messagesSection = {
    css: css`
        padding: 12px;
    `,
};

accountMessagesStyles.messageCardGridItem = {
    ...accountMessagesStyles.messageCardGridItem,
    css: css`
        :last-child {
            padding-bottom: 0;
        }
    `,
};
